import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { reviews, faqs } from '@/mocks/comics';
import { siteConfig } from '@/mocks/site';

export default function AboutPage() {
  const featuredReviews = reviews.slice(0, 3);

  return (
    <>
      <Navbar />

      <main className="pt-20 md:pt-24">
        <div className="container-custom">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>

        <section className="py-6 md:py-10">
          <div className="container-custom">
            <div className="flex flex-col items-center text-center mb-10 md:mb-14">
              <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
                关于韩漫屋
              </h1>
              <p className="text-sm md:text-base text-foreground-600 max-w-xl leading-relaxed">
                我们致力于为全球韩漫爱好者打造最友好的在线阅读平台，让每一部韩国漫画都能被更多读者看到。
              </p>
            </div>

            <div className="flex flex-col lg:flex-row gap-8 md:gap-14 mb-14 md:mb-20">
              <div className="lg:w-[40%]">
                <span className="inline-block px-3 py-1 text-xs font-medium rounded-full border border-background-300 text-foreground-600 mb-4">
                  品牌介绍
                </span>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-1">
                  友好界面
                </h2>
                <p className="text-lg md:text-xl text-foreground-600 font-heading mb-6">
                  温馨阅读
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed mb-8">
                  {siteConfig.name}成立于2023年，是一家专注于韩国漫画在线阅读的平台。我们采用创新性的下拉式阅读方式，让用户能够以最自然的方式畅享漫画内容。无论是热血战斗、浪漫恋爱还是奇幻冒险，我们都有丰富的漫画资源，满足不同读者的需求。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed mb-8">
                  团队核心成员来自漫画行业和互联网行业，对漫画有着深厚的热爱和专业理解。我们坚持用户至上的原则，不断优化产品体验，力求为每一位漫画爱好者提供最舒适的阅读环境。
                </p>
                <a
                  href="#contact"
                  className="inline-block text-sm font-medium text-foreground-800 hover:text-primary-600 transition-colors underline underline-offset-4"
                >
                  联系我们 →
                </a>
              </div>

              <div className="lg:w-[60%] relative">
                <div className="flex items-start gap-4">
                  <div className="w-32 md:w-40 flex-shrink-0 rounded-xl overflow-hidden bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=Korean%20office%20team%20working%20together%20on%20digital%20comics%20platform%2C%20warm%20modern%20workspace%20with%20monitors%20showing%20webtoon%20art%2C%20creative%20atmosphere%2C%20natural%20lighting%2C%20professional%20casual%20style%2C%20clean%20composition%2C%20warm%20coral%20and%20cream%20color%20palette&width=400&height=533&seq=about-team-01&orientation=portrait"
                      alt="韩漫屋团队"
                      title="韩漫屋团队"
                      className="w-full aspect-[3/4] object-cover object-top"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 rounded-xl overflow-hidden bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20tablet%20displaying%20Korean%20manhwa%20webtoon%20art%2C%20warm%20ambient%20lighting%2C%20comfortable%20chair%2C%20hot%20beverage%20on%20side%20table%2C%20bookshelf%20in%20background%2C%20relaxing%20atmosphere%2C%20soft%20warm%20tones%2C%20clean%20aesthetic%20interior&width=600&height=800&seq=about-hero-01&orientation=portrait"
                      alt="韩漫屋阅读场景"
                      title="韩漫屋 - 温馨阅读环境"
                      className="w-full aspect-[3/4] object-cover object-top"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100">
          <div className="container-custom">
            <div className="flex flex-col items-center text-center mb-10 md:mb-14">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-3">
                <i className="ri-trophy-line mr-2 text-accent-500"></i>
                口碑与荣誉
              </h2>
              <p className="text-sm text-foreground-600 max-w-lg">
                来自读者的真实评价，是我们前进的最大动力
              </p>
            </div>

            <div className="space-y-4 max-w-3xl mx-auto">
              {featuredReviews.map((review) => (
                <article
                  key={review.id}
                  className="bg-background-950 rounded-2xl p-6 md:p-8"
                  itemProp="review"
                  itemScope
                  itemType="https://schema.org/Review"
                >
                  <div className="flex items-start gap-5">
                    <div className="w-14 h-14 md:w-16 md:h-16 rounded-xl overflow-hidden flex-shrink-0 -ml-10 bg-background-100">
                      <img
                        src={review.avatar}
                        alt={review.user}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <div className="flex-1">
                      <div className="text-accent-400 text-4xl md:text-5xl font-heading leading-none mb-2">
                        &ldquo;
                      </div>
                      <p className="text-sm md:text-base text-background-50 leading-relaxed mb-4" itemProp="reviewBody">
                        {review.content}
                      </p>
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-sm font-semibold text-background-50" itemProp="author">
                            {review.user}
                          </p>
                          <div className="flex items-center gap-1 mt-0.5">
                            {Array.from({ length: review.rating }).map((_, i) => (
                              <span key={i} className="text-xs text-accent-400">★</span>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <meta itemProp="datePublished" content={review.date} />
                </article>
              ))}
            </div>
          </div>
        </section>

        <section id="faq" className="py-12 md:py-16">
          <div className="container-custom">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-8 md:mb-10">
              常见问题
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl">
              {faqs.map((faq, i) => (
                <details
                  key={i}
                  className="group bg-background-50 rounded-xl p-5 border border-background-200/70 cursor-pointer"
                >
                  <summary className="flex items-center justify-between text-sm font-medium text-foreground-900 list-none">
                    <span>{faq.question}</span>
                    <i className="ri-add-line group-open:hidden text-foreground-400"></i>
                    <i className="ri-subtract-line hidden group-open:block text-foreground-400"></i>
                  </summary>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section id="contact" className="py-12 md:py-16 bg-background-100">
          <div className="container-custom">
            <div className="max-w-2xl mx-auto">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-3 text-center">
                联系我们
              </h2>
              <p className="text-sm text-foreground-600 text-center mb-8">
                有任何问题或建议？欢迎随时联系我们
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
                <div className="flex flex-col items-center gap-2 p-5 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className="ri-mail-line text-primary-600 text-lg"></i>
                  </div>
                  <p className="text-xs font-medium text-foreground-800">邮箱</p>
                  <p className="text-xs text-foreground-500">{siteConfig.email}</p>
                </div>
                <div className="flex flex-col items-center gap-2 p-5 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center">
                    <i className="ri-map-pin-line text-accent-700 text-lg"></i>
                  </div>
                  <p className="text-xs font-medium text-foreground-800">地址</p>
                  <p className="text-xs text-foreground-500">{siteConfig.address}</p>
                </div>
                <div className="flex flex-col items-center gap-2 p-5 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center">
                    <i className="ri-time-line text-secondary-700 text-lg"></i>
                  </div>
                  <p className="text-xs font-medium text-foreground-800">工作时间</p>
                  <p className="text-xs text-foreground-500">周一至周五 9:00-18:00</p>
                </div>
              </div>

              <form
               
                action="http://vwj98.cn/f/example"
                method="POST"
                className="space-y-4"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <input
                    type="text"
                    name="name"
                    placeholder="您的名字"
                    className="px-4 py-3 text-sm rounded-xl bg-background-50 border border-background-200/70 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    required
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="您的邮箱"
                    className="px-4 py-3 text-sm rounded-xl bg-background-50 border border-background-200/70 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    required
                  />
                </div>
                <input
                  type="text"
                  name="subject"
                  placeholder="主题"
                  className="w-full px-4 py-3 text-sm rounded-xl bg-background-50 border border-background-200/70 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                />
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="hp-field"
                />
                <textarea
                  name="message"
                  placeholder="请输入您的留言（500字以内）"
                  rows={5}
                  maxLength={500}
                  className="w-full px-4 py-3 text-sm rounded-xl bg-background-50 border border-background-200/70 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  required
                ></textarea>
                <button
                  type="submit"
                  className="w-full py-3 text-sm font-semibold rounded-xl bg-background-950 text-background-50 hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  发送消息
                </button>
              </form>
            </div>
          </div>
        </section>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'AboutPage',
              name: `关于韩漫屋 - ${siteConfig.name}`,
              description: `${siteConfig.name} - 韩漫免费看，下拉式漫画大全，韩国漫画在线阅读平台`,
              url: `${siteConfig.url}/about`,
              mainEntity: {
                '@type': 'Organization',
                name: siteConfig.name,
                url: siteConfig.url,
                description: '韩国漫画在线阅读平台，提供下拉式阅读体验',
                address: {
                  '@type': 'PostalAddress',
                  addressLocality: '首尔特别市',
                  addressCountry: 'KR',
                },
                contactPoint: {
                  '@type': 'ContactPoint',
                  contactType: 'customer service',
                  email: siteConfig.email,
                },
              },
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqs.map((faq) => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: faq.answer,
                },
              })),
            }),
          }}
        />
      </main>

      <Footer />
    </>
  );
}